import React, { useState } from "react";
import "./plans.m.css";

const plans = [
  {
    planId: "1_YEAR_ACCESS",
    year: "1 Year",
    label: " Print+Digital",
    term: "No of Issues 51",
    price: "3470",
    mainPrice: "4080",
  },
  {
    planId: "2_YEAR_ACCESS",
    year: "2 Year",
    label: " Print+Digital",
    term: "No of Issues 102",
    price: "6120",
    mainPrice: "8160",
  },
  {
    planId: "3_YEAR_ACCESS",
    year: "3 Year",
    label: " Print+Digital",
    term: "No of Issues 153",
    price: "7960",
    mainPrice: "12240",
  },
];

const Plans = ({ selectedPlanId, onSelectPlan }) => {
  const handleSelectedplan = (planId) => {
    onSelectPlan(planId);

    // Scroll to details section
    const detailsSection = document.getElementById("details-section");
    if (detailsSection) {
      detailsSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const calculateDiscount = (price, mainPrice) => {
    const discount = ((mainPrice - price) / mainPrice) * 100;
    return Math.round(discount);
  };

  return (
    <div styleName="wrapper">
      {plans.map((plan, index) => (
        <div
          styleName={`plan-card ${selectedPlanId === plan.planId ? "active-plan" : ""}`}
          key={index}
          onClick={() => handleSelectedplan(plan.planId)}
        >
          <div styleName="radio-button">
            <div styleName={`radio-circle ${selectedPlanId === plan.planId ? "selected" : ""}`}>
              {selectedPlanId === plan.planId && <div styleName="radio-dot"></div>}
            </div>
          </div>
          <div styleName="plan-content">
            <div styleName="plan-and-price">
              <div styleName="label">
                <span>{plan.year}</span>
                <span>{plan.label}</span>
              </div>
              <div styleName="price-wrapper">
                <div styleName="price">₹{plan.price}</div>
                <div styleName="mainprice">₹{plan.mainPrice}</div>
                <div styleName="discount">-{calculateDiscount(plan.price, plan.mainPrice)}%</div>
              </div>
            </div>
            <div styleName="term">{plan.term}</div>
          </div>
          <div styleName="select">Select</div>
        </div>
      ))}
    </div>
  );
};

export default Plans;
